import { Component, HostListener } from '@angular/core';
import { Routes, Router } from '@angular/router';
import * as _ from 'lodash';
import { ToasterService } from 'angular2-toaster';
import { BaMenuService } from '../theme';
import { PAGES_AD_MENU } from './pages.ad.menu';
import { PAGES_SUB_MENU } from './pages.sub.menu';
import { Constants } from '../app.constant';
import { ComParentChildService } from '../services/parent-child.service';
import { NgbModal, NgbModalOptions, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Subject }    from 'rxjs/Subject';
import { AlertModalComponent } from './shared/components/alert-modal/alert-modal.component';
import { TpaService } from './general/components/third-party-app/services/tpa.service';
import { ErrorComponent } from './shared/components/errorComponent/error.component';
import { type } from 'os';
import { constants } from 'os';
@Component({
  selector: 'pages',
  template: `
    <ba-sidebar></ba-sidebar>
    <ba-page-top></ba-page-top>
    <div class="al-main">
      <div class="al-content">
        <!--<ba-content-top></ba-content-top>-->
        <router-outlet></router-outlet>
      </div>
    </div>
    <footer class="al-footer clearfix">
      <!-- div class="al-footer-right" translate>{{'general.created_with'}} <i class="ion-heart"></i></div -->
      <div class="al-footer-main clearfix">
        <div class="al-copy">
      <p *ngIf="!customerId"> &copy; 2018 - 2019. <span translate>{{'general.panasonic'}}<sup class="font-8">TM</sup> {{'general.footer'}}</span></p>
      <p *ngIf="customerId">{{_footerText}}</p>
		</div>
        <!-- ul class="al-share clearfix">
          <li><i class="socicon socicon-facebook"></i></li>
          <li><i class="socicon socicon-twitter"></i></li>
          <li><i class="socicon socicon-google"></i></li>
          <li><i class="socicon socicon-github"></i></li>
        </ul -->
      </div>
    </footer>
    <ba-back-top position="200"></ba-back-top>
    `
})
export class Pages {
  subscription;
  public inactiveTimer;
  public secondsDisplay;
  public minutesDisplay;
  public activeModal;  
  public error='';
  public customerId; 
  public _footerText:any; 
  constructor(
    private _menuService: BaMenuService,
    private comparentchildservice: ComParentChildService,
    private modalService: NgbModal,
    private _router: Router,
    private _tpaService :TpaService,
    private _err : ErrorComponent,
    private _toasterService:ToasterService
  ) {}

  @HostListener('document:keyup', ['$event'])
  @HostListener('document:click', ['$event'])
  @HostListener('document:wheel', ['$event'])
  @HostListener('document:mouseover', ['$event'])
  resetTimer () {
    this.clearTimer();
    this.initTimer(15);
  }
  ngOnInit() {
    this.subscription = this.comparentchildservice.on('call-parent').subscribe(() => this.updateMenu());
    this.updateMenu();
    this.resetTimer();
  }

    // end time in minutes   
    private initTimer (endTime: number) {      
      const interval = 1000;
      const duration = (endTime * 60);
      this.inactiveTimer = Observable.timer(0, interval)
        .take(duration)
        .subscribe(value => this.render((duration - +value) * interval),
          err => { },
          () => {
            if(!this.activeModal){
              this.activeModal = this.modalService.open(AlertModalComponent, { size: 'sm' });
              this.activeModal.componentInstance.modalHeader = 'Session Expiring!';
              this.activeModal.componentInstance.modalType = 'confirm';
              this.activeModal.componentInstance.modalContent = 'Your session is about to expire. Do you want to continue?';
              this.activeModal.componentInstance.successModal = (target) => this.goInactive(1);
              this.activeModal.componentInstance.cancelModal = (target) => this.goInactive(2);
              this.activeModal.componentInstance.closeModal = (target) => this.goInactive(3);
              this.activeModal.result.then((isConform) => {
                // console.log("conform > isConform :", isConform);
              }, (reason) => {
                // console.log("conform > dismiss");
              });
            }
          });          
    }

    private render (count) {
      this.secondsDisplay = this.getSeconds(count);
      this.minutesDisplay = this.getMinutes(count);
    }
  
    
    private getSeconds (ticks: number) {
      const seconds = ((ticks % 60000) / 1000).toFixed(0);    
      return this.pad(seconds);
    }
  
    private getMinutes (ticks: number) {
      const minutes = Math.floor(ticks / 60000);
      return this.pad(minutes);
    }
  
    private pad (digit: any) {
      return digit <= 9 ? '0' + digit : digit;
    }
    clearTimer () {
      if (this.inactiveTimer) {
        this.inactiveTimer.unsubscribe();        
      }
    }

    public goInactive(val: number){
      if(val==1)
      {
        this.activeModal.close();
        this.activeModal=false;
      }else if(val==2)
      {
        this.activeModal.close();
        this._router.navigate(['/logout']);
      }else{
        this.activeModal.close();
        this._router.navigate(['/logout']);
        return false;
      }
      
    }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.clearTimer();
  }

  public fetchTpaChildItems(){    
    this._tpaService.getTpaReportsForMenu()
    .finally(()=>this._menuService.updateMenuByRoutes(<Routes>PAGES_SUB_MENU))
    .subscribe(data => {
      if(data && data['result'] && data['result'].shouldShowTpaReportsMenu){        
        let value = data['result'].toBeShownTpaReportMenuItems
        Constants.Var.tpaChildItems=value        
      }else{
        Constants.Var.tpaChildItems=[];
      }
        Constants.Var.shouldShowTpaReports = data['result'].shouldShowTpaReports;
    },
      err => {
        if (_.isUndefined(err.error.result) && (!err.error.code)) {
          this._toasterService.pop('error', err.error.title, err.error.message);
        } else {
          this.error = err.error.message;
        }          
      });
  }
  public updateMenu() {
    // if(Constants.CurrentCustomerInfomations("customerType") == 'ADVANCED' || Constants.CurrentCustomerInfomations("customerType")== null){
      // this.comparentchildservice.publish('change-brand-logo');
    // }
    if(Constants.CurrentCustomerInfomations("customerId")){
      this.customerId = Constants.CurrentCustomerInfomations("customerId");
      this._footerText = Constants.CurrentBrandingDetails("footerText");
    }else{
      this.customerId = '';
      this._footerText = '';
    }
      console.log("change-brand-logo");
      this.comparentchildservice.publish('change-brand-logo');
    // }
    if (
      !(_.isEmpty(Constants.CurrentUserInfomations("userType"))) &&
      (!Constants.CurrentCustomerInfomations("customerId"))
    ) {
      this._menuService.updateMenuByRoutes(<Routes>PAGES_AD_MENU);
    } else {
      this.fetchTpaChildItems();           
      // this._menuService.updateMenuByRoutes(<Routes>PAGES_SUB_MENU)
    }
  }
   
}



// WEBPACK FOOTER //
// ./src/app/pages/pages.component.ts